/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_RATINGS(state, ratings) {
    state.ratings = ratings
  },
  SET_RATINGS_COUNT(state, count) {
    state.ratingsCount = count
  },
  SET_RATINGS1(state, ratings1) {
    state.ratings1 = ratings1
  },
  SET_RATINGS2(state, ratings2) {
    state.ratings2 = ratings2
  },
  SET_RATINGS3(state, ratings3) {
    state.ratings3 = ratings3
  },

}